import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import MultiDemo from './MultiDemo';

const Hero: React.FC = () => {
  const { user } = useAuth();

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden gradient-bg pt-32">
      {/* Floating Orbs - Corporate Colors */}
      <div className="floating-orb w-96 h-96 bg-blue-600 top-20 left-20"></div>
      <div className="floating-orb w-64 h-64 bg-slate-700 top-40 right-32"></div>
      <div className="floating-orb w-80 h-80 bg-cyan-600 bottom-20 left-1/3"></div>
      
      {/* Grid Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
          backgroundImage: `
            linear-gradient(rgba(14, 165, 233, 0.1) 1px, transparent 1px),
            linear-gradient(90deg, rgba(14, 165, 233, 0.1) 1px, transparent 1px)
          `,
          backgroundSize: '50px 50px'
        }}></div>
      </div>
      
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        {/* Professional Badge */}
        <div className="inline-flex items-center px-6 py-3 rounded-full glass-effect text-white text-sm font-medium mb-12 neon-border">
          <div className="w-2 h-2 bg-blue-400 rounded-full mr-3 animate-pulse"></div>
          <span className="gradient-text font-semibold">Enterprise AI Voice Technology</span>
        </div>

        {/* Main Headline - Professional messaging */}
        <h1 className="text-5xl md:text-7xl lg:text-8xl font-black leading-none tracking-tight mb-8" style={{
          background: 'linear-gradient(135deg, #ffffff 0%, #0ea5e9 50%, #06b6d4 100%)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          backgroundClip: 'text',
          textShadow: '0 0 40px rgba(14, 165, 233, 0.2)'
        }}>
          Transform Your
          <br />
          <span className="gradient-text">Customer Experience</span>
          <br />
          with AI
        </h1>

        {/* Professional Subheadline */}
        <p className="text-xl md:text-2xl text-gray-300 mb-12 max-w-4xl mx-auto leading-relaxed font-light">
          Deploy enterprise-grade <span className="text-white font-semibold">AI voice agents</span> that deliver 
          exceptional customer service. <span className="gradient-text">Reduce costs by 60%</span>, 
          <span className="gradient-text">scale infinitely</span>, and maintain 24/7 availability.
        </p>

        {/* Multi-Demo Interface */}
        <div className="relative max-w-5xl mx-auto mb-12">
          <MultiDemo />
        </div>

        {/* Professional Stats */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto mb-20">
          <div className="glass-card p-6 rounded-2xl card-hover">
            <div className="text-5xl font-black gradient-text mb-2">99.9%</div>
            <div className="text-gray-400 font-medium">Uptime SLA</div>
          </div>
          <div className="glass-card p-6 rounded-2xl card-hover">
            <div className="text-5xl font-black gradient-text mb-2">60%</div>
            <div className="text-gray-400 font-medium">Cost Reduction</div>
          </div>
          <div className="glass-card p-6 rounded-2xl card-hover">
            <div className="text-5xl font-black gradient-text mb-2">24/7</div>
            <div className="text-gray-400 font-medium">Always Available</div>
          </div>
        </div>
      </div>
      
      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <svg className="w-6 h-6 text-white/50" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
        </svg>
      </div>
    </section>
  );
};

export default Hero;